import { render, staticRenderFns } from "./case-dialog.vue?vue&type=template&id=3d01c178"
import script from "./case-dialog.vue?vue&type=script&lang=js"
export * from "./case-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports